module.exports = __webpack_public_path__ + "img/feature2.c14cb17e.png";